import { Action } from '@ngrx/store';
import { Unit } from '../../settings-module/models/unit';

export enum ActionTypes {
  LoadUserEmployments = '[Employment] Load User Employments',
  LoadCompanyEmployments = '[Employment] Load Company Employments',
  LoadUserEmploymentsSuccess = '[Employment] Load User Employments Success',
  LoadUserEmploymentsFail = '[Employment] Load User Employments Fail',
  LoadCurrentUnit = '[Employment] Load Current Unit',
  LoadCurrentUnitSuccess = '[Employment] Load Current Unit Success',
  LoadCurrentUnitFail = '[Employment] Load Current Unit Fail',
  LoadCompanyEmploymentsSuccess = '[Employment] Load Company Employments Success',
  LoadEmploymentsFail = '[Employment] Load Employments Fail',
}

export class LoadUserEmployments implements Action {
  readonly type = ActionTypes.LoadUserEmployments;
}

export class LoadUserEmploymentsSuccess implements Action {
  readonly type = ActionTypes.LoadUserEmploymentsSuccess;

  constructor(public payload: { userEmployments: any[]; pagination: {} }) {}
}

export class LoadUserEmploymentsFail implements Action {
  readonly type = ActionTypes.LoadUserEmploymentsFail;

  constructor(public payload: { errors: any }) {}
}

export class LoadCurrentUnit implements Action {
  readonly type = ActionTypes.LoadCurrentUnit;

  constructor(public payload: { selectedUnitId: number }) {}
}

export class LoadCurrentUnitSuccess implements Action {
  readonly type = ActionTypes.LoadCurrentUnitSuccess;

  constructor(public payload: { selectedUnit: Unit }) {}
}

export class LoadCurrentUnitFail implements Action {
  readonly type = ActionTypes.LoadCurrentUnitFail;

  constructor(public payload: { errors: any }) {}
}

export class LoadCompanyEmployments implements Action {
  readonly type = ActionTypes.LoadCompanyEmployments;

  constructor(public payload: { companyId: number }) {}
}

export class LoadCompanyEmploymentsSuccess implements Action {
  readonly type = ActionTypes.LoadCompanyEmploymentsSuccess;

  constructor(public payload: { companyEmployments: any[] }) {}
}

export class LoadEmploymentsFail implements Action {
  readonly type = ActionTypes.LoadEmploymentsFail;

  constructor(public payload: { errors: any }) {}
}

export type Actions =
  | LoadUserEmployments
  | LoadUserEmploymentsSuccess
  | LoadUserEmploymentsFail
  | LoadCurrentUnit
  | LoadCurrentUnitSuccess
  | LoadCurrentUnitFail
  | LoadCompanyEmployments
  | LoadCompanyEmploymentsSuccess
  | LoadEmploymentsFail;
